module.exports = __webpack_public_path__ + "static/img/aboutUs_banner01.ca3fdf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/aboutUs_banner01.png
// module id = bQ8w
// module chunks = 1